import React from 'react';
import { Box } from '@chakra-ui/react';
import PropType from 'prop-types';

function TabPanelBox({ children, ...props }) {
  return (
    <Box position="relative" w="100%" {...props}>
      {children}
    </Box>
  );
}

TabPanelBox.propTypes = {
  children: PropType.arrayOf(PropType.element)
};

export default TabPanelBox;
